import { Injectable } from '@angular/core';
import { usePreset } from '@primeng/themes';



import GreenAlva from '../../../assets/theme/green.alva'
import OrangeTest from '../../../assets/theme/orange.reduno';
import {BehaviorSubject} from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class ThemeService  {
  private currentTheme = new BehaviorSubject<'green' | 'orange'>(this.getStoredTheme());

  setTheme(themeName: 'green' | 'orange') {
    if (typeof window === 'undefined') return;
    const preset = themeName === 'green' ? GreenAlva : OrangeTest;
    usePreset(preset);
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem('selectedTheme', themeName);
    }
    this.currentTheme.next(themeName); // notifica a los suscriptores
  }

  loadStoredTheme() {
    if (typeof window === 'undefined') return;
    const theme = this.getStoredTheme();
    this.setTheme(theme);
  }

  getStoredTheme(): 'green' | 'orange' {
    if (typeof localStorage === 'undefined') return 'green';
    return (localStorage.getItem('selectedTheme') as 'green' | 'orange') || 'green';
  }

  getThemeObservable() {
    return this.currentTheme.asObservable();
  }
}
